import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { BrokerService } from '../../../services/broker/broker.service';

@Injectable({
  providedIn: 'root'
})
export class BrokerGuard implements CanActivate {
  constructor(private brokerService: BrokerService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.brokerService.isLoggedIn()) {
      return true;
    }
    this.router.navigate(['/broker/login'], { queryParams: { returnUrl: state.url } });
    return false;
  }
}
